/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import r from '../../../util/Renderer'
import MonthlyClosingAction from '../../../action/monthly_closing'
import { BaseLayout, ListViewLayout } from 'ui-library/dist/external/layouts'
import {
  DataTable,
  DataTableColumn as TD,
  DataTableHeader as TH,
  DataTableRow as TR,
  Detail,
  List,
  ListRow,
  ListRowItem,
  NavigationDrawer,
  OutlinedButton,
  ToolbarDateNavigation
} from 'ui-library/dist/external/components'
import LocalDate from '../../../domain/type/Date'
import Date from '../../unit/Date'
import ClosingStatus from '../../../domain/model/closing/Status'
import Money from '../../unit/Money'
import { Link } from 'react-router-dom'

function ListView(props) {
  const date = props.match.params.date
  const monthly_close_date = date ? LocalDate.parse(date) : LocalDate.today().beginningOfMonth()

  const toolbar = { label: `月次締め`, items: props.accountMenu }

  const paginations = {
    current: {
      label: '今月',
      onClick: e => {
        const target = LocalDate.today()
          .beginningOfMonth()
          .toISODate()
        MonthlyClosingAction.onMonthChanged(target)
      }
    },
    prev: {
      onClick: e => {
        const target = props.search.search_monthly_close_date.lastMonth().toISODate()
        MonthlyClosingAction.onMonthChanged(target)
      }
    },
    next: {
      onClick: e => {
        const target = props.search.search_monthly_close_date.nextMonth().toISODate()
        MonthlyClosingAction.onMonthChanged(target)
      }
    }
  }

  const meta = {
    component: ToolbarDateNavigation,
    data: { label: props.search.search_monthly_close_date.format('yyyy年MM月'), paginations: paginations }
  }

  return (
    <React.Fragment>
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} meta={meta} />

      <BaseLayout>
        <ListViewLayout>
          <DataTable
            headers={[
              <TH key={1} width="9%">
                ステータス
              </TH>,
              <TH key={2} width="20%">
                宿泊施設
              </TH>,
              <TH key={3} width="12%" isNumber>
                宿泊料金
              </TH>,
              <TH key={4} width="12%" isNumber>
                決済手数料
              </TH>,
              <TH key={5} width="12%" isNumber>
                入金額
              </TH>,
              <TH key={6} width="10%" isNumber>
                稼働日数
              </TH>,
              <TH key={7} width="7%" isNumber>
                保存
              </TH>,
              <TH key={8} width="7%" isNumber>
                締め済
              </TH>,
              <TH key={9} width="11%" />
            ]}
            rows={props.heads.map((head, index) => (
              <TR key={index} onClick={e => MonthlyClosingAction.showDetailView(monthly_close_date, head)}>
                <TD>
                  <MonthlyClosingStatus>{head.status}</MonthlyClosingStatus>
                </TD>
                <TD>{head.hotel_name}</TD>
                <TD isNumber>
                  <Sales head={head} />
                </TD>
                <TD isNumber>
                  <SalesPayCommission head={head} />
                </TD>
                <TD isNumber>
                  <ReservationReceipt head={head} />
                </TD>
                <TD isNumber>
                  <span>{head.occupancy_dates}</span>
                </TD>
                <TD isNumber>
                  <DailyClosingSavedCount count={head.daily_closing_count.saved_count} />
                </TD>
                <TD isNumber>{head.daily_closing_count.closed_count}</TD>
                <TD>
                  <OutlinedButton onClick={() => MonthlyClosingAction.toEditView(head.id, head.hotel_id, props.search.search_monthly_close_date.toISODate())}>月次締め</OutlinedButton>
                </TD>
              </TR>
            ))}
          />
        </ListViewLayout>

        {r.renderIf(props.showDetail)(
          <Detail onDeactivate={e => MonthlyClosingAction.hideDetailView(date)}>
            <MonthlyDetail daily_closings={props.daily_closings} />
          </Detail>
        )}
      </BaseLayout>
    </React.Fragment>
  )
}

function MonthlyDetail(props) {
  return (
    <React.Fragment>
      <List>
        <ListRow>
          <ListRowItem width={'400px'} overline={'販売日数'} primaryText={`${props.daily_closings.occupancy_dates} 日`} />
        </ListRow>
      </List>
      <List>
        {props.daily_closings.daily_closings.map(item => {
          const daily_closing_reservations = item.daily_closing_reservations
          return daily_closing_reservations.map((daily_closing_reservation, index) => (
            <ListRow key={`${item.id}-${index}`}>
              <ListRowItem
                width={'400px'}
                overline={
                  <React.Fragment>
                    <MonthlyClosingStatus>{item.status}</MonthlyClosingStatus>&nbsp;
                    <Link to={`/daily/id/${item.id}/edit`} target="_blank">
                      ID: {item.id}
                    </Link>
                    &nbsp;&nbsp; 締め日:&nbsp;<Date>{item.close_date}</Date>
                  </React.Fragment>
                }
                primaryText={item.room_name}
              />
              <DailyClosingReservationItem daily_closing_reservation={daily_closing_reservation} />
            </ListRow>
          ))
        })}
      </List>
    </React.Fragment>
  )
}

function DailyClosingReservationItem(props) {
  const daily_closing_reservation = props.daily_closing_reservation
  const tax = daily_closing_reservation.reservation.accommodation_tax ? daily_closing_reservation.reservation.accommodation_tax : {}
  const accom_tax = Math.ceil(tax.tax_per_day * (tax.number_of_nights * tax.number_of_guests))
  const accom_pay_comsn = tax.payment_commission

  return (
    <React.Fragment>
      <ListRowItem
        width={'400px'}
        primaryText={daily_closing_reservation.reservation.name}
        secondaryText={
          <React.Fragment>
            滞在:&nbsp;
            <Date>{daily_closing_reservation.reservation.check_in}</Date>&nbsp;→&nbsp;<Date>{daily_closing_reservation.reservation.check_out}</Date>&nbsp;&nbsp;
          </React.Fragment>
        }
      />
      <ListRowItem
        width={'480px'}
        secondaryItem={
          <React.Fragment>
            <Caption>OTA: {daily_closing_reservation.reservation.site_referer}</Caption>&nbsp;&nbsp;
            <Caption>
              OTA手数料: <Money>{daily_closing_reservation.ota_comsn}</Money>
            </Caption>
          </React.Fragment>
        }
      />
      <ListRowItem
        width={'480px'}
        secondaryItem={
          <React.Fragment>
            <Caption>
              宿泊料金: <Money>{daily_closing_reservation.rsvn_sales}</Money>
            </Caption>
            &nbsp;&nbsp;
            <Caption>
              決済手数料: <Money>{daily_closing_reservation.rsvn_pay_comsn}</Money>
            </Caption>
          </React.Fragment>
        }
      />
      <ListRowItem
        width={'480px'}
        secondaryItem={
          <React.Fragment>
            <Caption>入金額(宿泊料金): </Caption> <Money>{daily_closing_reservation.rsvn_sales - daily_closing_reservation.rsvn_pay_comsn}</Money>
          </React.Fragment>
        }
      />
      <ListRowItem
        width={'480px'}
        secondaryItem={
          <React.Fragment>
            <Caption>
              宿泊税: <Money>{accom_tax}</Money>
            </Caption>
            &nbsp;&nbsp;
            <Caption>
              決済手数料: <Money>{accom_pay_comsn}</Money>
            </Caption>
          </React.Fragment>
        }
      />
      <ListRowItem
        width={'480px'}
        secondaryItem={
          <React.Fragment>
            <Caption>入金額(宿泊税):</Caption> <Money>{accom_tax - accom_pay_comsn}</Money>
          </React.Fragment>
        }
      />
    </React.Fragment>
  )
}

function Caption(props) {
  return <small style={{ WebkitFontSmoothing: 'antialiased' }}>{props.children}</small>
}

function Sales(props) {
  if (props.head.status !== ClosingStatus.CLOSED) {
    return <span>-</span>
  }

  return <Money>{props.head.rsvn_sales}</Money>
}

function SalesPayCommission(props) {
  if (props.head.status !== ClosingStatus.CLOSED) {
    return <span>-</span>
  }

  return <Money>{props.head.rsvn_pay_comsn}</Money>
}

function ReservationReceipt(props) {
  if (props.head.status !== ClosingStatus.CLOSED) {
    return <span>-</span>
  }

  return <Money>{props.head.rsvn_sales - props.head.rsvn_pay_comsn}</Money>
}

function OtaCommission(props) {
  if (props.head.status !== ClosingStatus.CLOSED) {
    return <span>-</span>
  }

  return <Money>{props.head.ota_comsn}</Money>
}

function DailyClosingSavedCount(props) {
  const count = props.count
  let style = {}
  if (count > 0) {
    style = { color: 'red' }
  }
  return <span style={style}>{count}</span>
}

function MonthlyClosingStatus(props) {
  const status = props.children
  const code = ClosingStatus.getCode(status)

  // 暫定対応: ui-libraryに移行する
  const style = {
    fontSize: '0.68rem',
    WebkitFontSmoothing: 'subpixel-antialiased',
    textAlign: 'center',
    width: '48px',
    display: 'inline-block',
    padding: '2px',
    borderRadius: '12px',
    color: '#fff'
  }

  if (code === ClosingStatus.SAVED) {
    style['backgroundColor'] = '#A2A2A2'
  } else if (code === ClosingStatus.CLOSED) {
    style['backgroundColor'] = '#4DB5F0'
  } else {
    style['backgroundColor'] = '#F06464'
  }

  return <small style={style}>{ClosingStatus.getLabel(status)}</small>
}

export default ListView
